import React, { Component } from 'react';
import PivotTableUI from 'react-pivottable/PivotTableUI';
import 'react-pivottable/pivottable.css';
import TableRenderers from 'react-pivottable/TableRenderers';
import Plot from 'react-plotly.js';
import createPlotlyRenderers from 'react-pivottable/PlotlyRenderers';

const PlotlyRenderers = createPlotlyRenderers(Plot);

class PivotTablejs extends Component {
  constructor(props) {
    super(props);
    this.state = props;
  }

  updateFunction() {
    const { activitiesByDate, redirectData } = this.props;
    const columnLabels = document.querySelectorAll('.pvtColLabel');
    let rowLabels = document.querySelectorAll('.pvtRowLabel');
    let VerticalTitle = document.getElementsByClassName('pvtAxisLabel');
    VerticalTitle = Array.from(VerticalTitle);
    const assettable = JSON.parse(JSON.stringify(activitiesByDate));
    VerticalTitle.forEach((x) => {
      if (x.innerText === 'title') {
        let labels;
        if (columnLabels.length) {
          labels = columnLabels;
        } else if (rowLabels.length) {
          labels = rowLabels;
        }
        labels.forEach((label, index) => {
          label.classList.add('hover-title');
          label.addEventListener('click', function handleClick(event) {
            assettable?.forEach((data) => {
              const labelTitle = label.innerText
                ?.replace('&#x0022;', '"')
                ?.replace('&#x005D;', ']')
                ?.replace('&#x005B;', '[')
                ?.replace('0xFE5B', '{')
                ?.replace('0xFE5C', '}')
                ?.replace('U+003B', ';')
                .replace('U+003A', ':');
              const dataTitle = data.title
                ?.replace('&#x0022;', '"')
                ?.replace('&#x005D;', ']')
                ?.replace('&#x005B;', '[')
                ?.replace('0xFE5B', '{')
                ?.replace('0xFE5C', '}')
                ?.replace('U+003B', ';')
                .replace('U+003A', ':');

              if (labelTitle === dataTitle) {
                redirectData(data.id);
              }
            });
          });
        });
      }
    });
    //     let cell_Index_Of_Title = 0;
    //     // setTimeout(()=>{
    //     //For Vertical
    //     let VerticalTitle = document.getElementsByClassName('pvtAxisLabel');
    //     //For Horizontal
    //     let arrayData3 = document.getElementsByClassName('pvtRowLabel');
    //     VerticalTitle = Array.from(VerticalTitle);
    // VerticalTitle.forEach((x) => {
    //   let redirect = this.props;
    //   if (x.innerText === 'title') {
    //     cell_Index_Of_Title = x.cellIndex;
    //     function getNextSiblings(elem, filter) {
    //       var sibs = [];
    //       // eslint-disable-next-line
    //       while ((elem = elem.nextSibling)) {
    //         if (elem.nodeType === 3) continue; // text node
    //         if (!filter || filter(elem)) sibs.push(elem);
    //       }
    //       sibs.forEach((data) => {
    //         let texts = data.innerHTML.split('/')[0];
    //         let LinkID = data.innerHTML.split('/')[1];
    //         data.innerText = texts;
    //         // data.innerHTML=data.innerHTML.split('/')[0];
    //         data.addEventListener('click', () => {
    //           redirect.redirectData(LinkID);
    //         });
    //       });
    //     }
    //     getNextSiblings(x);
    //   }
    // });
    // let HOrData = Array.from(arrayData3);
    // let newArr = [];
    // HOrData.forEach((x) => {
    //   if (x.innerText.includes('/')) {
    //     newArr.push(x.parentElement);
    //   }
    // });
    // newArr.forEach((y) => {
    //   if (y.children[cell_Index_Of_Title].innerText.includes('/')) {
    //     let LinkID = y.children[cell_Index_Of_Title].innerText.split('/')[1];
    //     y.children[cell_Index_Of_Title].innerText =
    //       y.children[cell_Index_Of_Title].innerHTML.split('/')[0];
    //     y.children[cell_Index_Of_Title].addEventListener('click', () => {
    //       this.props.redirectData(LinkID);
    //     });
    //   }
    // });
    //   }, 100)
  }
  componentDidMount() {
    setTimeout(() => {
      this.updateFunction();
    }, 500);
  }

  render() {
    const removeCol = 'isdeleted';
    const assettable = JSON.parse(JSON.stringify(this.props.activitiesByDate));
    assettable?.filter((data) => {
      return data.title && (data.title = data?.title?.split('/')[0]);
    });
    if (this.props.customer === 'LVP CMS - AM') {
      assettable?.forEach((o) => {
        // asset_in_vault
        o['asset_in_room'] = o['asset_in_Vault'];
        o['physical_location_room'] = o['physical_location_vault'];
        delete o['physical_location_vault'];
        delete o['asset_in_vault'];
      });
    }
    if (
      this.props.chosenPivotReportKeys?.includes('title') &&
      !this.props.chosenPivotReportKeys?.includes('id')
    ) {
      assettable?.forEach((o) => {
        delete o['id'];
      });
      if (this.props.chosenPivotReportKeys?.includes('title')) {
        assettable?.forEach((o) => {
          o['title'] = o['title']
            ?.replace('&#x0022;', '"')
            ?.replace('&#x005D;', ']')
            ?.replace('&#x005B;', '[')
            ?.replace('0xFE5B', '{')
            ?.replace('0xFE5C', '}')
            ?.replace('U+003B', ';')
            .replace('U+003A', ':');
        });
      }
    }
    assettable.map((i) => removeCol.split(',').map((j) => delete i[j]));
    return (
      <div
        style={{
          width: '100vw',
          overflowY: 'auto',
          padding: '10px 20px',
        }}
      >
        <PivotTableUI
          rows={this.props.rows}
          cols={this.props.cols}
          data={assettable}
          onChange={(s) => {
            this.setState(s);
            this.updateFunction();
            this.props.setPivotRowandColumn(s.rows, s.cols);
            // setPivotRowandColumn(s.row,s.col)
          }}
          renderers={Object.assign({}, TableRenderers, PlotlyRenderers)}
          {...this.state}
        />
      </div>
    );
  }
}

export default PivotTablejs;
